import { render, staticRenderFns } from "./ApplicantEducationsQuestion.vue?vue&type=template&id=2d169c78"
import script from "./ApplicantEducationsQuestion.vue?vue&type=script&lang=js"
export * from "./ApplicantEducationsQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports